export function getVendorPhones(vendor: any): string[] {
  const list = Array.isArray(vendor?.phones)
    ? vendor.phones.map((p: any) => p?.phone).filter(Boolean)
    : []
  if (list.length > 0) return list
  return vendor?.phone ? [vendor.phone] : []
}
